import { render, staticRenderFns } from "./asset-device-config.vue?vue&type=template&id=124d5578&scoped=true&"
import script from "./asset-device-config.vue?vue&type=script&lang=js&"
export * from "./asset-device-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d5578",
  null
  
)

export default component.exports